import React from 'react';

const MeetingPanelEmptyState = ({ selectedCircleIsRole }) => (
  <div className="bg-white p-6 rounded-lg shadow-md h-full flex flex-col items-center justify-center text-slate-500 text-sm gap-3">
    <div className="text-base font-semibold text-slate-700">Aucune réunion ouverte</div>
    <p className="text-xs text-slate-400 text-center">
      {selectedCircleIsRole
        ? "Sélectionnez un cercle (pas un rôle) pour accéder à une réunion."
        : "Ouvrez ou rejoignez une réunion depuis l'onglet Structure."}
    </p>
  </div>
);

export default MeetingPanelEmptyState;
